import React from 'react';
import { Settings, Bell, Globe, Sun, Moon, Monitor } from 'lucide-react';

function SettingsSection() {
  return (
    <div className="p-8 space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white">Settings</h2>
        <p className="text-slate-400 mt-1">Configure system preferences</p>
      </div>

      <div className="glass-panel divide-y divide-slate-800/50">
        <div className="p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Globe className="w-5 h-5 text-purple-400" />
            <div>
              <p className="text-white font-medium">Default Language</p>
              <p className="text-xs text-slate-500">Portuguese (Brazil)</p>
            </div>
          </div>
          <select className="bg-slate-800 border border-slate-700 text-white text-sm rounded-xl px-3 py-2">
            <option>pt-BR</option>
            <option>en-US</option>
            <option>es-ES</option>
          </select>
        </div>

        <div className="p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Bell className="w-5 h-5 text-amber-400" />
            <div>
              <p className="text-white font-medium">Notifications</p>
              <p className="text-xs text-slate-500">Alerts for system events</p>
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" defaultChecked className="sr-only peer" />
            <div className="w-11 h-6 bg-slate-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600" />
          </label>
        </div>

        <div className="p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Monitor className="w-5 h-5 text-emerald-400" />
            <div>
              <p className="text-white font-medium">Theme</p>
              <p className="text-xs text-slate-500">Dark mode enabled</p>
            </div>
          </div>
          <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-slate-800 text-slate-400">Dark</span>
        </div>
      </div>
    </div>
  );
}

export default SettingsSection;
